<template>
    <div id="webshop--wrapper"
         :class="{ 'static': static }"
         class="col-span-main">
        <transition name="fade">
            <add-to-cart-modal v-cloak
               v-if="$store.getters.showModal('addToCart')"
               :style="`z-index: ${ 200 + $store.getters.modalZDepth('addToCart')}`"
               @load-cart="loadCart"
               @close-modal="addingToCartModal = false"></add-to-cart-modal>
        </transition>
        
        <transition name="fade">
            <alternatives-modal v-cloak
                v-if="$store.getters.showModal('alternatives')"
                :style="`z-index: ${ 200 + $store.getters.modalZDepth('alternatives')}`"
                @add-to-cart="addToCart"
                @add-to-order="addToOrder"
                @close-modal="addingToCart = false; addingToCartModal = false"></alternatives-modal>
        </transition>
        
        <ais-instant-search
            :index-name="indexName"
            :initial-ui-state="initialUiState"
            :middlewares="middlewares"
            :routing="routing"
            :search-client="searchClient"
        >
            
            <ais-configure
                :clickAnalytics="true"
                :filters="algoliaFilters"
                :hits-per-page.camel="static ? 999999 : !showAllProducts && isBestB ? 100 : 24"
                :optional-filters.camel="algoliaOptionalFilters"
            />
            
            <div id="webshop--container" class="w-full grid grid-cols-12">
                <!-- Mobile search -->
                <div v-if="!static" class="col-span-12 nm:hidden w-full form mb-4">
                    <ais-search-box :placeholder="$t('Zoek jouw product op nummer of naam')">
                        <template v-slot:submit-icon>
                            <svg id="icon-search"
                                 height="15"
                                 viewBox="0 0 40 40"
                                 width="15"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
                                      fill-rule="evenodd"></path>
                            </svg>
                        </template>
                        <template v-slot:reset-icon>
                            <img src="/assets/img/icon-clear.png"
                                 :alt="$t('Clear')">
                        </template>
                    </ais-search-box>
                    <button class="btn btn--icon-centered w-full mt-4"
                            @click="toggleFilterPanel()">
                        <span aria-hidden="true"
                              class="fas fa-filter mr-2"></span>
                        {{ $t('Filter') }}
                    </button>
                </div>
                
                <transition name="fade">
                    <div v-if="!static && showFilterPanel" class="filter-panel-overlay"></div>
                </transition>
                
                <transition v-cloak name="slide-in-left">
                    <div v-cloak
                         v-show="!static && showFilterPanel"
                         ref="filterPanel"
                         class="filters-panel">
                        
                        <!-- Mobile close btn -->
                        <button class="btn btn--icon filters-panel__close-btn"
                                @click="toggleFilterPanel()">
                        <span aria-hidden="true"
                              class="fas fa-times mr-2"></span>
                            {{ $t('Close') }}
                        </button>
                        
                        <div v-if="loggedIn" class="mb-6 flex gap-2 flex-col">
                            <button v-if="isBestB && showBestBProducts.length" :class="{ 'btn--fill': !showAllProducts && !showFavorites }"
                                    class="btn w-full h-full"
                                    @click="showAllProducts = false; showFavorites = false;">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                        <path d="M1,4.125V1.5a.5.5,0,1,0-1,0v4A.5.5,0,0,0,.5,6h4a.5.5,0,0,0,0-1H1.675A7,7,0,1,1,2.4,12.2a.5.5,0,1,0-.8.6A8,8,0,1,0,1,4.125ZM8,4a.5.5,0,0,0-.5.5V8a.5.5,0,0,0,.147.353l2.5,2.5a.5.5,0,0,0,.706-.706L8.5,7.794V4.5A.5.5,0,0,0,8,4Z" />
                                    </svg>
                                </span>
                                <span class="flex-grow">{{ $t("Bestelhistoriek") }}</span>
                            </button>

                            <button :class="{ 'btn--fill': showFavorites }"
                                    class="btn w-full h-full"
                                    @click="showAllProducts = false; showFavorites = true;">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13.66" viewBox="0 0 16 13.66">
                                        <path d="M7.625,45.532,7.25,45.11l-.131-.147A3.5,3.5,0,0,0,1,47.291V47.4A3.625,3.625,0,0,0,2.159,50.06l5.747,5.353A.147.147,0,0,0,8,55.451a.132.132,0,0,0,.094-.037l5.75-5.353A3.634,3.634,0,0,0,15,47.4v-.109a3.5,3.5,0,0,0-6.119-2.328l-.131.147-.375.422A.5.5,0,0,1,8,45.7.507.507,0,0,1,7.625,45.532Zm1.091-1.784A4.5,4.5,0,0,1,16,47.291V47.4a4.631,4.631,0,0,1-1.144,3.047c-.106.119-.216.234-.334.344l-5.75,5.353a.858.858,0,0,1-.081.069A1.124,1.124,0,0,1,8,56.448a1.15,1.15,0,0,1-.775-.3l-5.75-5.35c-.119-.109-.228-.225-.334-.344A4.658,4.658,0,0,1,0,47.4v-.109a4.5,4.5,0,0,1,7.281-3.544,4.415,4.415,0,0,1,.584.55L8,44.445l.131-.147a4.278,4.278,0,0,1,.416-.409l.169-.141Z" transform="translate(0 -42.788)" />
                                    </svg>
                                </span>
                                <span class="flex-grow">{{ $t("Mijn favorieten") }}</span>
                            </button>

                            <button :class="{ 'btn--fill': showAllProducts }"
                                    class="btn w-full h-full"
                                    @click="initShowAllProducts()">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14.222" viewBox="0 0 16 14.222">
                                        <path d="M10.667.889a.888.888,0,0,1,.889.889V5.333h.889V1.778A1.779,1.779,0,0,0,10.667,0H5.333A1.779,1.779,0,0,0,3.556,1.778V5.333h.889V1.778A.888.888,0,0,1,5.333.889h.889V2.444A1.111,1.111,0,0,0,7.333,3.556H8.667A1.111,1.111,0,0,0,9.778,2.444V.889Zm-3.556,0H8.889V2.444a.223.223,0,0,1-.222.222H7.333a.223.223,0,0,1-.222-.222ZM9.1,14.222h5.122A1.779,1.779,0,0,0,16,12.444V8a1.779,1.779,0,0,0-1.778-1.778H9.1a2.641,2.641,0,0,1,.528.889h.15V8.667a1.111,1.111,0,0,0,1.111,1.111h1.333a1.111,1.111,0,0,0,1.111-1.111V7.111h.889A.888.888,0,0,1,15.111,8v4.444a.888.888,0,0,1-.889.889h-4.6a2.641,2.641,0,0,1-.528.889Zm1.567-7.111h1.778V8.667a.223.223,0,0,1-.222.222H10.889a.223.223,0,0,1-.222-.222Zm-3.556,0A.888.888,0,0,1,8,8v4.444a.888.888,0,0,1-.889.889H1.778a.888.888,0,0,1-.889-.889V8a.888.888,0,0,1,.889-.889h.889V8.667A1.111,1.111,0,0,0,3.778,9.778H5.111A1.111,1.111,0,0,0,6.222,8.667V7.111ZM3.556,8.667V7.111H5.333V8.667a.223.223,0,0,1-.222.222H3.778A.223.223,0,0,1,3.556,8.667ZM7.111,6.222H1.778A1.779,1.779,0,0,0,0,8v4.444a1.779,1.779,0,0,0,1.778,1.778H7.111a1.779,1.779,0,0,0,1.778-1.778V8A1.779,1.779,0,0,0,7.111,6.222Z"/>
                                    </svg>
                                </span>
                                <span class="flex-grow">{{ $t("Alle producten") }}</span>
                            </button>
                        </div>
                        
                        <algolia-sorting-select :is-sales="isSales"
                            :lang="lang"
                            class="nm:hidden mb-6" />
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.channels = !filtersActiveState.channels">
                                {{ $t('Channels') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.channels }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            <ais-refinement-list
                                v-show="filtersActiveState.channels"
                                :limit="10"
                                :searchable="false"
                                :show-more="true"
                                :show-more-limit="9999"
                                :sort-by="['name:asc']"
                                :transform-items="transformFilters"
                                attribute="channels"
                                operator="or"
                            />
                        </div>
                        
                        <div v-if="loggedIn" class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.focusAssortment = !filtersActiveState.focusAssortment">
                                {{ $t('Premium selection') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.focusAssortment }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            <ais-refinement-list
                                v-show="filtersActiveState.focusAssortment"
                                :limit="10"
                                :searchable="false"
                                :show-more="true"
                                :show-more-limit="9999"
                                :sort-by="['name:asc']"
                                attribute="focusAssortment"
                                :transform-items="transformFilters"
                                operator="or"
                            />
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.general = !filtersActiveState.general">
                                {{ $t('Algemeen') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.general }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            <ul class="filter-menu__list" v-show="filtersActiveState.general">
                                <ais-toggle-refinement
                                    v-if="user && showPrivateLabelIds.length"
                                    :label="$t('Private label')"
                                    :on="true"
                                    attribute="privateLabel"
                                />
                                <li class="ais-RefinementList-label">
                                    <input id="new"
                                           v-model="customFilters"
                                           type="checkbox"
                                           value="new">
                                    <label for="new">{{ $t('Nieuwe producten') }}</label>
                                </li>
                                <li v-if="user.priceGroup !== 'Grossiers'" class="ais-RefinementList-label">
                                    <input id="promo"
                                           v-model="customFilters"
                                           type="checkbox"
                                           value="promo">
                                    <label for="promo">{{ $t('Promoties') }}</label>
                                </li>
                                <li class="ais-RefinementList-label">
                                    <input id="bargain-sale"
                                           v-model="customFilters"
                                           type="checkbox"
                                           value="bargainSale">
                                    <label for="bargain-sale">{{ $t('bargainSale') }}</label>
                                </li>
                            </ul>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.themes = !filtersActiveState.themes">
                                {{ $t('Themes') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.themes }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            <ais-refinement-list
                                v-show="filtersActiveState.themes"
                                :searchable="false"
                                :limit="9999"
                                attribute="themes"
                                operator="or"
                                :transform-items="transformThemes"
                            />
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.labels = !filtersActiveState.labels">
                                {{ $t('Labels') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.labels }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            
                            <template v-if="filtersActiveState.labels">
                                <ul class="label-refinements">
                                    <!-- These are not Algolia toggles because we need to add privateLabel:true to them -->
                                    <li v-if="user && user.isUtz">
                                        <input id="utz"
                                               v-model="customFilters"
                                               type="checkbox"
                                               value="utz">
                                        <label for="utz">{{ $t('UTZ') }}</label>
                                    </li>
                                    <li v-if="user && user.isFairtrade">
                                        <input id="fairtrade"
                                               v-model="customFilters"
                                               type="checkbox"
                                               value="fairtrade">
                                        <label for="fairtrade">{{ $t('Fairtrade') }}</label>
                                    </li>

                                    <!-- This is an algolia toggle -->
                                    <ais-toggle-refinement
                                        :label="$t('Bio')"
                                        :on="true"
                                        attribute="bio"
                                    />
                                </ul>
                            </template>
                        </div>
                        
                        <div v-if="isSales && showBestB"
                             class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.salesIcons = !filtersActiveState.salesIcons">
                                {{ $t('Sales') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.salesIcons }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            <ais-hierarchical-menu
                                v-show="filtersActiveState.salesIcons"
                                :attributes="facets.icon"
                                :show-more="false"
                                :transform-items="transformFilters"
                            />
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.categories = !filtersActiveState.categories">
                                {{ $t('Categorieën') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.categories }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            <ais-hierarchical-menu
                                v-show="filtersActiveState.categories"
                                :attributes="facets.categories"
                                :limit="20"
                                :show-more="true"
                                :show-more-limit="9999"
                                :transform-items="relabelCategories"
                            />
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.brands = !filtersActiveState.brands">
                                {{ $t('Merken') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.brands }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            <ais-hierarchical-menu
                                v-show="filtersActiveState.brands"
                                :attributes="facets.brands"
                                :limit="20"
                                :show-more="true"
                                :show-more-limit="9999"
                            >
                                <template v-slot:showMoreLabel="{ isShowingMore }">
                                    {{ isShowingMore ? $t('Show less') : $t('Show more') }}
                                </template>
                            </ais-hierarchical-menu>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading">{{ $t('Materiaal') }}</p>
                            <div class="filter-menu__list">

                                <ais-menu-select :class-names="{ 'ais-MenuSelect': 'filter-select-styling' }"
                                                 :limit="9999"
                                                 attribute="filters.Materiaal">
                                    <template v-slot="{ items, canRefine, refine, sendEvent }">
                                        <select
                                            :disabled="!canRefine"
                                            @change="refine($event.currentTarget.value)"
                                        >
                                            <option value="">{{ $t("See all") }}</option>
                                            <option
                                                v-for="item in items"
                                                :key="item.value"
                                                :selected="item.isRefined"
                                                :value="item.value"
                                            >
                                                {{ $t(item.label) }} ({{ item.count }})
                                            </option>
                                        </select>
                                    </template>
                                </ais-menu-select>
                            </div>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading">{{ $t('Aantal in doos') }}</p>
                            <div class="filter-menu__body">
                                <ais-range-input
                                    :limit="9999"
                                    :precision="0"
                                    attribute="filters.Aantal in doos"
                                >
                                    <span slot="submitLabel">
                                        <img alt="Filter"
                                             class="icon-go"
                                             src="/assets/img/arrow-select-dark.png">
                                    </span>
                                    <span slot="separator">{{ $t('tot') }}</span>
                                </ais-range-input>
                            </div>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading"
                               @click="filtersActiveState.bakingType = !filtersActiveState.bakingType">
                                {{ $t('Bak type') }}
                                <svg :class="{ 'transform rotate-180': !filtersActiveState.bakingType }"
                                     height="19"
                                     viewBox="0 0 448 512"
                                     width="16"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                                           />
                                </svg>
                            </p>
                            <ais-hierarchical-menu
                                v-show="filtersActiveState.bakingType"
                                :attributes="facets.bakingType"
                                :limit="10"
                                :show-more="true"
                                :show-more-limit="9999"
                                :sort-by="sortFilters"
                                :transform-items="transformFiltersBakingTypes"
                            >
                                <template v-slot="{ items, refine, createURL }">
                                    <ul class="ais-HierarchicalMenu-list ais-HierarchicalMenu-list--lvl0">
                                        <li class="ais-HierarchicalMenu-item" v-for="item in items" :key="item.label">
                                            <a class="ais-HierarchicalMenu-link" :href="createURL(item.value)" @click.prevent="refine(item.value)">
                                                <span class="ais-HierarchicalMenu-label flex items-center">
                                                    <span class="w-6 mr-6"><img v-if="item.icon" :src="`/assets/img/baking-type/${item.icon}.svg`"></span>
                                                    <span>{{ item.label }}</span>
                                                </span>
                                                <span class="ais-HierarchicalMenu-count" v-if="item.count !== undefined"> {{ item.count }}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </template>
                            </ais-hierarchical-menu>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading">{{ $t('Weight') }} ({{ $t('g') }})</p>
                            <div class="filter-menu__body">
                                <ais-range-input
                                    :limit="9999"
                                    :precision="0"
                                    attribute="weight"
                                >
                                    <span slot="submitLabel">
                                        <img alt="Filter"
                                             class="icon-go"
                                             src="/assets/img/arrow-select-dark.png">
                                    </span>
                                    <span slot="separator">{{ $t('tot') }}</span>
                                </ais-range-input>
                            </div>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading">{{ $t('Volume') }} ({{ $t('ml') }})</p>
                            <div class="filter-menu__body">
                                <ais-range-input
                                    :limit="9999"
                                    :precision="0"
                                    attribute="volume"
                                >
                                    <span slot="submitLabel">
                                        <img alt="Filter"
                                             class="icon-go"
                                             src="/assets/img/arrow-select-dark.png">
                                    </span>
                                    <span slot="separator">{{ $t('tot') }}</span>
                                </ais-range-input>
                            </div>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading">{{ $t('Height') }} ({{ $t('cm') }})</p>
                            <div class="filter-menu__body">
                                <ais-range-input
                                    :limit="9999"
                                    :precision="0"
                                    attribute="height"
                                >
                                    <span slot="submitLabel">
                                        <img alt="Filter"
                                             class="icon-go"
                                             src="/assets/img/arrow-select-dark.png">
                                    </span>
                                    <span slot="separator">{{ $t('tot') }}</span>
                                </ais-range-input>
                            </div>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading">{{ $t('Width') }} ({{ $t('cm') }})</p>
                            <div class="filter-menu__body">
                                <ais-range-input
                                    :limit="9999"
                                    :precision="0"
                                    attribute="width"
                                >
                                <span slot="submitLabel">
                                    <img alt="Filter"
                                         class="icon-go"
                                         src="/assets/img/arrow-select-dark.png">
                                </span>
                                    <span slot="separator">{{ $t('tot') }}</span>
                                </ais-range-input>
                            </div>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading">{{ $t('Length') }} ({{ $t('cm') }})</p>
                            <div class="filter-menu__body">
                                <ais-range-input
                                    :limit="9999"
                                    :precision="0"
                                    attribute="length"
                                >
                                    <span slot="submitLabel">
                                        <img alt="Filter"
                                             class="icon-go"
                                             src="/assets/img/arrow-select-dark.png">
                                    </span>
                                    <span slot="separator">{{ $t('tot') }}</span>
                                </ais-range-input>
                            </div>
                        </div>
                        
                        <div class="filter-menu">
                            <p class="filter-menu__heading">{{ $t('Diameter') }} ({{ $t('cm') }})</p>
                            <div class="filter-menu__body">
                                <ais-range-input
                                    :limit="9999"
                                    :precision="0"
                                    attribute="diameter"
                                >
                                    <span slot="submitLabel">
                                        <img alt="Filter"
                                             class="icon-go"
                                             src="/assets/img/arrow-select-dark.png">
                                    </span>
                                    <span slot="separator">{{ $t('tot') }}</span>
                                </ais-range-input>
                            </div>
                        </div>
                    </div>
                </transition>
                
                <div :class="{ 'nm:col-start-4': !static }"
                     class="col-span-12 nm:col-end-13">
                    <div v-if="!static"
                         class="search-bar bg-white">
                        <div class="form flex flex-col mb-3 nm:flex-row nm:items-center">
                            <div class="hidden nm:block nm:w-1/2 mb-4 nm:mb-0">
                                <ais-search-box :placeholder="$t('Zoek jouw product op nummer of naam')">
                                    <template v-slot:submit-icon>
                                        <svg id="icon-search"
                                             height="15"
                                             viewBox="0 0 40 40"
                                             width="15"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
                                                  fill-rule="evenodd"></path>
                                        </svg>
                                    </template>
                                    <template v-slot:reset-icon>
                                        <img src="/assets/img/icon-clear.png"
                                             :alt="$t('Clear')">
                                    </template>
                                </ais-search-box>
                            </div>
                            <div class="hidden md:items-center md:mb-4 md:flex nm:mb-0 nm:ml-4 nm:w-1/2">
                                <algolia-sorting-select :is-sales="isSales"
                                                        :lang="lang"
                                                        class="hidden nm:block" />
                            </div>
                            <div class="hidden md:flex md:mb-4 md:gap-2 nm:mb-0 nm:ml-4">
                                <svg :class="{ 'active': algoliaView === 'list-view' }"
                                     class="btn-view"
                                     height="32"
                                     viewBox="0 0 24 24"
                                     width="32"
                                     xmlns="http://www.w3.org/2000/svg"
                                     @click="$store.dispatch('setAlgoliaView', 'list-view')">
                                    <rect height="6"
                                          rx="2"
                                          width="24" />
                                    <rect height="6"
                                          rx="2"
                                          width="24"
                                          y="9" />
                                    <rect height="6"
                                          rx="2"
                                          width="24"
                                          y="18" />
                                </svg>
                                <svg :class="{ 'active': algoliaView === 'grid-view' }"
                                     class="btn-view"
                                     height="32"
                                     viewBox="0 0 24 24"
                                     width="32"
                                     xmlns="http://www.w3.org/2000/svg"
                                     @click="$store.dispatch('setAlgoliaView', 'grid-view')">
                                    <rect height="11"
                                          rx="2"
                                          width="11" />
                                    <rect height="11"
                                          rx="2"
                                          width="11"
                                          y="13" />
                                    <rect height="11"
                                          rx="2"
                                          width="11"
                                          x="13"
                                          y="13" />
                                    <rect height="11"
                                          rx="2"
                                          width="11"
                                          x="13" />
                                </svg>
                            </div>
                        </div>
                        <div class="flex justify-between items-center mb-4">
                            <ais-clear-refinements>
                                <template v-slot="{ canRefine, refine, createURL }">
                                    <a class="font-medium" :href="createURL()"
                                       @click.prevent="initFilters(refine)">
                                               <span aria-hidden="true"
                                                     class="fas fa-times mr-2"></span>

                                        {{ $t("Reset filters") }}
                                    </a>
                                </template>
                            </ais-clear-refinements>
                            
                            <ais-stats>
                                <template v-slot="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }">
                                    {{ nbHits }} {{ $t("products - page") }} {{ page + 1 }}/{{ nbPages }}
                                </template>
                            </ais-stats>
                        
                        </div>
                        <template v-if="user && directOrder">
                            <div class="stock-legend" :class="legendActive ? 'stock-legend--active' : ''">
                                <div class="stock-legend__toggle" @click="toggleLegend()">
                                    <span class="stock-legend__toggle-label">
                                        <i class="fas fa-info-circle"></i>
                                        <span>{{ $t("De stockindicatie heeft geen garantie op tijdig levering.") }}</span>
                                    </span>
                                    <span class="stock-legend__toggle-button">
                                        <img src="/assets/img/arrow-select-dark.png" class="stock-legend__toggle-button" :class="legendActive ? 'rotate-180 transform' : ''">
                                    </span>
                                </div>
                                <div class="stock-legend__body">
                                    <div class="inline-flex gap-1 items-center">
                                        <i class="dot dot--stock-green"></i>
                                        <span>{{ $t("Onmiddelijk leverbaar") }}</span>
                                    </div>
                                    <div class="inline-flex gap-1 items-center">
                                        <i class="dot dot--stock-orange"></i>
                                        <span>{{ $t("Laatste stuks") }}</span>
                                    </div>
                                    <div class="inline-flex gap-1 items-center">
                                        <i class="dot dot--stock-light-blue"></i>
                                        <span>{{ $t("Met levertermijn") }}</span>
                                    </div>
                                    <div class="inline-flex gap-1 items-center">
                                        <i class="dot dot--stock-ranson-blue"></i>
                                        <span>{{ $t("Onmiddellijk leverbaar via leverancier") }}</span>
                                    </div>
                                    <div class="inline-flex gap-1 items-center">
                                        <i class="dot dot--stock-red"></i>
                                        <span>{{ $t("Uit gamma met alternatief") }}</span>
                                    </div>
                                </div>
                                <div class="stock-legend__footer">
                                    {{ $t("lastUpdated", { date: new Date().toLocaleDateString(['nl-BE'], { month: '2-digit', day: '2-digit', year: 'numeric' }), time: syncTime }) }}
                                </div>
                            </div>
                        </template>

                        <ais-current-refinements>
                            <template v-slot="{ items, createURL }">
                                <template v-for="item in items">
                                    <template v-for="refinement in item.refinements">
                                        <a class="tag tag--refinement" :href="createURL(refinement)" @click.prevent="item.refine(refinement)">
                                            {{ transformCurrentRefinements(refinement) }}
                                            <span aria-hidden="true" class="fas fa-times-circle"></span>
                                        </a>
                                    </template>
                                </template>
                                <template v-for="refinementCustom in customFilters">
                                    <button class="tag tag--refinement" @click.prevent="toggleCustomFilter(refinementCustom)">
                                        {{ $t(refinementCustom) }}
                                        <span aria-hidden="true" class="fas fa-times-circle"></span>
                                    </button>
                                </template>
                            </template>
                        </ais-current-refinements>
                    </div>
                    
                    <ais-hits ref="aisHits" :transform-items="transformItems">
                        <template v-slot="{ items, sendEvent }">
                            <div :class="static ? 'static grid-view' : algoliaView">
                                <div v-if="showFavorites && !userFavorites.length">
                                    {{ $t("Geen favorieten gevonden") }}
                                </div>
                                <product-card v-for="item in items" :key="item.objectID"
                                    :show-as="static ? 'grid-view' : algoliaView"
                                    :item="item"
                                    :logged-in="loggedIn"
                                    :is-sales="isSales"
                                    :in-sales-app="inSalesApp"
                                    :in-kiosk-app="inKioskApp"
                                    :is-best-b="isBestB"
                                    :user="user"
                                    :sync-time="syncTime"
                                    :login-url="loginUrl"
                                    :default-price="defaultPrice(item.objectID)"
                                    :price-fetched="priceFetched(item.objectID)"
                                    :volume-discounts="volumeDiscounts(item.objectID)"
                                    :products-in-order="productsInOrder"
                                    :prop-qty="currentQty(item.objectID)"
                                    :direct-order="directOrder"
                                    @send-event="sendEvent"
                                    @toggle-qty-focus="toggleQtyFocus"
                                    @update-qty="updateQty"
                                    @add-product-to-cart-modal="addProductToCartModal"
                                    @add-product-to-cart="addProductToCart"
                                    @add-product-to-order="addProductToOrder"
                                    @remove-product-from-order="removeProductFromOrder"
                                    @remove-from-best-b="removeFromBestB"
                                    @show-pay-by-email-modal="showPayByEmailModal"
                                ></product-card>
                            </div>
                        </template>
                    </ais-hits>
                    
                    <ais-pagination v-if="!static"
                                    @page-change="pageChange" />
                    
                    <small class="block mt-12"><sup>*</sup> {{ $t("priceEstimateInfo") }}</small>
                </div>
            </div>
        </ais-instant-search>
    
    </div>
</template>

<script>
import { helpers } from "@/js/mixins/helpers.js"
import algoliasearch from "algoliasearch/lite"

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { checkQueue, createQueue, destroyQueue, fetchQueue, killQueue } from 'fetch-queue'
import { history } from 'instantsearch.js/es/lib/routers';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import searchInsights from 'search-insights'
import { mapState } from "vuex"

import AddToCartModal from "./AddToCartModal.vue"
import AlgoliaSortingSelect from "./AlgoliaSortingSelect.vue"
import AlternativesModal from "./AlternativesModal.vue"
import ProductPrice from "./ProductPrice.vue"
import StockModal from "./StockModal.vue"
import ProductCard from "./components/ProductCard.vue"

const insightsMiddleware = createInsightsMiddleware({
    insightsClient: searchInsights
});

export default {
    name: "AlgoliaWebshop",
    mixins: [helpers],
    components: { AlgoliaSortingSelect, ProductPrice, AddToCartModal, AlternativesModal, StockModal, ProductCard },
    
    props: {
        /* UID is used to set a flag per webshop block/component.
         * All components use the same Vuex store, and we need to know which block we are viewing in the template.
         */
        uid: {
            type: String,
            default: "default"
        },
        // Static means that it only shows products without filtering or searching
        static: {
            type: Boolean,
            default: false
        },
        // Sorting -> check Algolia indexes for correct ID: eg. [products_nl_]ID
        sortingId: {
            type: String,
            default: ""
        },
        // If it is a directOrder items are added to the cart. If not, they are added to a saved order.
        directOrder: {
            type: Boolean,
            default: true
        },
        // Initial UI state
        initUiState: {
            type: [Object, Boolean, Array],
            default: false
        },
        user: {
            type: [Array, Object, Boolean],
            default: null
        },
        loggedIn: {
            type: Boolean,
            default: false,
        },
        inSalesApp: {
            type: Boolean,
            default: true,
        },
        inKioskApp: {
            type: Boolean,
            default: false,
        },
        isSales: {
            type: Boolean,
            default: false,
        },
        // Used for bestB
        showBestBProducts: {
            type: Array,
            default: () => []
        },
        // Used for products block
        showProductIds: {
            type: Array,
            default: () => []
        },
        showPrivateLabelIds: {
            type: Array,
            default: () => []
        },
        backorderProductIds: {
            type: Array,
            default: () => []
        },
        favoriteProductIds: {
            type: Array,
            default: () => []
        },
        // Show toggle button between BestB and all products
        isBestB: {
            type: Boolean,
            default: false
        },
        obProducts: {
            type: Boolean,
            default: false
        },
        newProducts: {
            type: Boolean,
            default: false
        },
        promoProducts: {
            type: Boolean,
            default: false
        },
        utz: {
            type: Boolean,
            default: false
        },
        fairtrade: {
            type: Boolean,
            default: false
        },
        bargainSale: {
            type: Boolean,
            default: false
        },
        // Used for category pages and webshop block where we need to pre-filter products
        preFilters: {
            type: Array,
            default: () => []
        },
        // Used to show the products within a saved order
        productsInCurrentOrder: {
            type: Array,
            default: () => []
        },
        // Focus channels -> products are put on top
        focusChannels: {
            type: Array,
            default: () => []
        },
        loginUrl: {
            type: String,
            default: '/login'
        },
        isUkSite: {
            type: Boolean,
            default: false
        },
        syncTime: {
            type: String,
            default: false
        }
    },
    
    data() {
        return {
            // ON/OFF switch pricing API
            forceDisablePricingAPI: false,
            enablePricingAPI: true,
            searchClient: algoliasearch(
                'VOYNA2HOMW',
                'a40c9abd596160f234d82e9c7bf3597b'
            ),
            middlewares: [insightsMiddleware],
            view: 'grid-view',
            filtersActiveState: {
                general: true,
                labels: true,
                categories: true,
                brands: true,
                bakingType: true,
                salesIcons: true,
                themes: true,
                channels: true,
                focusAssortment: true
            },
            showAllProducts: false,
            showFavorites:false,
            brandFilter: null,
            productAlternatives: null,
            productsInOrder: [],
            quantities: [],
            productPrices: [],
            addingToCart: false,
            addingToCartModal: false,
            lang: window.language,
            facets: {
                categories: [
                    'categories.lvl0',
                    'categories.lvl1',
                    'categories.lvl2'
                ],
                icon: [
                    'icon'
                ],
                brands: [
                    'brand.category.lvl0',
                    'brand.category.lvl1',
                    'brand.category.lvl2',
                ],
                bakingType: [
                    'filters.Baktype'
                ]
            },
            qtyUpdateTimeout: null,
            qtyFocusId: null,
            showFilterPanel: false,
            debounceSearchTimer: null,
            legendActive: (window.innerWidth > 959),
            routing: {
                router: history()
            },
            psLogo: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.11 174.68" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><linearGradient id="a" x1="0" y1="88.66" x2="159.11" y2="88.66" gradientTransform="matrix(1 0 0 -1 0 176)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#efbe48"/><stop offset=".12" stop-color="#f8db77"/><stop offset=".21" stop-color="#ffee97"/><stop offset=".67" stop-color="#efa64c"/><stop offset="1" stop-color="#efbe48"/></linearGradient></defs><path d="M55.15 174.68c-5.37 0-10.35-2.79-13.17-7.35L2.3 102.87C-2.18 95.59.09 86.07 7.36 81.6c7.27-4.48 16.8-2.2 21.27 5.06l26.52 43.08L130.49 7.36c4.47-7.27 13.98-9.55 21.27-5.06 7.27 4.48 9.53 14 5.06 21.27L68.31 167.33a15.47 15.47 0 01-13.17 7.35h.01z" fill="url(#a)"/></svg>`,
            psLogoFull: `<svg id="Laag_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1813.24 163.77" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><clipPath id="clippath"><path d="M1715.77 163.77c-5.03 0-9.7-2.62-12.35-6.89l-37.2-60.43c-4.2-6.83-2.07-15.75 4.74-19.94 6.82-4.2 15.75-2.06 19.94 4.74l24.86 40.39L1786.4 6.9c4.19-6.82 13.11-8.95 19.94-4.74 6.82 4.2 8.93 13.13 4.74 19.94l-82.97 134.78a14.506 14.506 0 01-12.35 6.89z" fill="none"/></clipPath><style>.cls-54{fill:#001689}.cls-59{fill:#efbb49}.cls-60{fill:#efb54a}.cls-61{fill:#efb74a}.cls-63{fill:#efa64c}.cls-64{fill:#efac4b}.cls-65{fill:#efa74c}.cls-66{fill:#efb14b}.cls-67{fill:#efaf4b}.cls-69{fill:#efb949}.cls-71{fill:#efb34a}.cls-85{fill:#f1b156}.cls-107{fill:#ffee97}.cls-111{fill:#ffed95}.cls-119{fill:#efbd49}.cls-121{fill:#efbe48}.cls-124{fill:#f2b55a}.cls-139{fill:#feeb93}.cls-163{fill:#efaa4b}</style></defs><path class="cls-54" d="M0 161.44V4.35h57.11c33.54 0 64.11 8.92 64.11 50.31s-33.12 50.95-64.53 50.95H34.4v55.83H0zm34.39-82.58h23.56c21.44 0 29.51-8.28 29.51-23.35s-7.85-22.93-29.51-22.93H34.39v46.28zM136.08 161.44V48.29h34.18v18.89h.21c6.16-9.55 16.98-21.23 38.21-21.23h1.06l-.42 30.36c-1.27-.21-6.79-.64-8.92-.64-13.59 0-23.78 7.22-30.14 15.5v70.26h-34.18zM214.84 104.97c0-43.94 33.54-59.01 56.89-59.01s52.01 11.68 52.01 63.05v5.09H248.8c1.7 18.68 12.1 25.9 26.32 25.9 13.37 0 25.9-6.58 33.54-13.59l13.16 20.38c-13.16 11.25-29.51 16.98-49.25 16.98-29.51 0-57.74-15.07-57.74-58.8zm78.33-11.04c-1.7-15.92-8.92-23.56-21.65-23.56-10.61 0-19.74 7.01-22.29 23.56h43.94zM343.48 161.44V48.29h34.18v17.83c6.79-8.92 19.32-20.17 37.15-20.17 18.89 0 27.81 7.85 30.99 20.17 6.79-8.7 19.53-20.17 37.36-20.17 22.93 0 33.12 14.44 33.12 34.6v80.88H482.1V89.69c0-10.19-2.33-15.5-12.31-15.5-8.49 0-15.28 4.67-22.71 11.25v76H412.9V89.69c0-10.19-2.33-15.5-12.31-15.5-8.49 0-15.28 4.67-22.93 11.25v76h-34.18zM542.4 32.8V5.41h34.39V32.8H542.4zm.21 128.64V48.29h33.96v113.15h-33.96zM602.68 130.87V48.29h34.18v72.6c0 10.19 3.82 15.71 13.37 15.71s16.98-4.88 24.62-11.46V48.29h34.18v113.15h-34.18v-17.62c-6.79 8.7-19.32 19.95-39.06 19.95s-33.12-9.55-33.12-32.9h.01zM734.94 161.44V48.29h34.18v17.83c6.79-8.92 19.32-20.17 37.15-20.17 18.89 0 27.81 7.85 30.99 20.17 6.79-8.7 19.53-20.17 37.36-20.17 22.93 0 33.12 14.44 33.12 34.6v80.88h-34.18V89.69c0-10.19-2.33-15.5-12.31-15.5-8.49 0-15.28 4.67-22.71 11.25v76h-34.18V89.69c0-10.19-2.33-15.5-12.31-15.5-8.49 0-15.28 4.67-22.93 11.25v76h-34.18z"/><g><path class="cls-54" d="M915.68 127.46l9.34-3.82c7.43 18.68 19.74 30.78 39.27 30.78 20.8 0 33.96-12.52 33.96-30.14 0-21.23-16.77-29.93-34.6-38.85-19.74-9.98-40.55-19.96-40.55-47.55 0-21.23 16.77-36.51 38.85-36.51 23.78 0 37.15 15.5 43.73 32.05l-9.34 3.82c-5.31-13.16-15.71-26.54-34.39-26.54-16.77 0-28.66 11.46-28.66 27.17 0 21.23 16.98 29.93 34.6 38.85 19.74 9.98 40.55 20.17 40.55 47.55 0 22.5-18.04 39.48-44.15 39.48-23.78 0-39.48-13.37-48.61-36.3zM1027.77 105.59c0-38.85 18.26-57.95 40.33-57.95 24.62 0 37.36 21.23 37.36 56.04v1.91h-67.72c.42 31.42 12.1 49.25 30.36 49.25 14.22 0 21.44-9.13 27.17-23.99l8.49 3.61c-7.22 18.68-19.1 29.29-36.3 29.29-22.93 0-39.7-20.59-39.7-58.17zm67.51-8.91c-1.06-22.29-9.34-40.12-27.38-40.12-14.44 0-27.81 12.95-29.93 40.12h57.31zM1131.36 4.34h9.76v157.09h-9.76V4.34zM1167.24 105.59c0-38.85 18.26-57.95 40.33-57.95 24.62 0 37.36 21.23 37.36 56.04v1.91h-67.72c.42 31.42 12.1 49.25 30.36 49.25 14.22 0 21.44-9.13 27.17-23.99l8.49 3.61c-7.22 18.68-19.1 29.29-36.3 29.29-22.93 0-39.7-20.59-39.7-58.17zm67.51-8.91c-1.06-22.29-9.34-40.12-27.38-40.12-14.44 0-27.81 12.95-29.93 40.12h57.31zM1264.25 105.81c0-39.06 18.04-58.17 40.76-58.17 20.17 0 29.29 14.86 34.6 31.21l-9.34 2.97c-4.46-14.22-11.04-25.26-25.69-25.26-15.71 0-30.36 15.28-30.36 49.04 0 29.51 11.89 49.25 30.36 49.25 14.22 0 22.08-9.13 26.96-25.26l8.92 2.76c-6.58 20.8-19.32 31.42-36.51 31.42-22.93 0-39.7-21.65-39.7-57.95zM1369.97 137.86V58.89h-16.77v-8.92h16.77V9.43h9.76v40.54h24.84v8.92h-24.84v77.69c0 11.46 2.97 17.41 15.5 17.41 3.61 0 7.22-.42 9.77-1.49v8.92c-2.97.85-6.58 1.49-10.4 1.49-16.56 0-24.62-6.37-24.62-25.05h-.01zM1429.19 9.64h10.19v13.8h-10.19V9.64zm.21 40.33h9.76v111.45h-9.76V49.97zM1465.27 105.81c0-36.72 16.77-58.17 41.39-58.17s41.39 21.44 41.39 58.17-16.77 57.95-41.39 57.95-41.39-21.65-41.39-57.95zm72.81-.21c0-25.9-9.76-49.04-31.42-49.04s-31.42 21.23-31.42 49.04c0 26.11 9.55 49.25 31.42 49.25 20.59 0 31.42-21.02 31.42-49.25zM1573.12 49.98h9.76v16.35c8.49-8.7 22.29-18.68 36.3-18.68 19.11 0 27.81 10.61 27.81 30.78v83h-9.77V79.7c0-15.5-5.31-23.14-19.11-23.14-12.31 0-24.84 8.49-35.24 19.1v85.76h-9.76V49.97h.01z"/></g><g clip-path="url(#clippath)"><path class="cls-121" d="M1662.02-2.05h2.04v165.82h-2.04zM1664.06-2.05h.44v165.82h-.44z"/><path fill="#efbf4a" d="M1664.51-2.05h.44v165.82h-.44z"/><path fill="#efc04b" d="M1664.95-2.05h.44v165.82h-.44z"/><path fill="#f0c14c" d="M1665.39-2.05h.44v165.82h-.44z"/><path fill="#f0c14d" d="M1665.83-2.05h.44v165.82h-.44z"/><path fill="#f0c24f" d="M1666.27-2.05h.44v165.82h-.44z"/><path fill="#f0c350" d="M1666.71-2.05h.44v165.82h-.44z"/><path fill="#f1c451" d="M1667.15-2.05h.44v165.82h-.44z"/><path fill="#f1c452" d="M1667.59-2.05h.44v165.82h-.44z"/><path fill="#f1c554" d="M1668.03-2.05h.44v165.82h-.44z"/><path fill="#f1c655" d="M1668.47-2.05h.44v165.82h-.44z"/><path fill="#f2c756" d="M1668.91-2.05h.44v165.82h-.44z"/><path fill="#f2c757" d="M1669.35-2.05h.44v165.82h-.44z"/><path fill="#f2c858" d="M1669.79-2.05h.44v165.82h-.44z"/><path fill="#f3c95a" d="M1670.23-2.05h.44v165.82h-.44z"/><path fill="#f3ca5b" d="M1670.67-2.05h.44v165.82h-.44z"/><path fill="#f3ca5c" d="M1671.12-2.05h.44v165.82h-.44z"/><path fill="#f3cb5d" d="M1671.56-2.05h.44v165.82h-.44z"/><path fill="#f4cc5e" d="M1672-2.05h.44v165.82h-.44z"/><path fill="#f4cd60" d="M1672.44-2.05h.44v165.82h-.44z"/><path fill="#f4cd61" d="M1672.88-2.05h.44v165.82h-.44z"/><path fill="#f4ce62" d="M1673.32-2.05h.44v165.82h-.44z"/><path fill="#f5cf63" d="M1673.76-2.05h.44v165.82h-.44z"/><path fill="#f5cf64" d="M1674.2-2.05h.44v165.82h-.44z"/><path fill="#f5d065" d="M1674.64-2.05h.44v165.82h-.44z"/><path fill="#f5d167" d="M1675.08-2.05h.44v165.82h-.44z"/><path fill="#f6d268" d="M1675.52-2.05h.44v165.82h-.44z"/><path fill="#f6d269" d="M1675.95-2.05h.44v165.82h-.44z"/><path fill="#f6d36a" d="M1676.39-2.05h.44v165.82h-.44z"/><path fill="#f6d46b" d="M1676.83-2.05h.44v165.82h-.44z"/><path fill="#f7d46c" d="M1677.27-2.05h.44v165.82h-.44z"/><path fill="#f7d56e" d="M1677.72-2.05h.44v165.82h-.44z"/><path fill="#f7d66f" d="M1678.16-2.05h.44v165.82h-.44z"/><path fill="#f7d770" d="M1678.6-2.05h.44v165.82h-.44z"/><path fill="#f7d771" d="M1679.04-2.05h.44v165.82h-.44z"/><path fill="#f8d872" d="M1679.48-2.05h.44v165.82h-.44z"/><path fill="#f8d973" d="M1679.92-2.05h.44v165.82h-.44z"/><path fill="#f8d974" d="M1680.36-2.05h.44v165.82h-.44z"/><path fill="#f8da76" d="M1680.8-2.05h.44v165.82h-.44z"/><path fill="#f9db77" d="M1681.24-2.05h.44v165.82h-.44z"/><path fill="#f9db78" d="M1681.68-2.05h.44v165.82h-.44z"/><path fill="#f9dc79" d="M1682.12-2.05h.44v165.82h-.44z"/><path fill="#f9dd7a" d="M1682.56-2.05h.44v165.82h-.44z"/><path fill="#fadd7b" d="M1683-2.05h.44v165.82h-.44z"/><path fill="#fade7c" d="M1683.44-2.05h.44v165.82h-.44z"/><path fill="#fadf7d" d="M1683.88-2.05h.44v165.82h-.44z"/><path fill="#fadf7f" d="M1684.32-2.05h.44v165.82h-.44z"/><path fill="#fae080" d="M1684.77-2.05h.44v165.82h-.44z"/><path fill="#fbe181" d="M1685.21-2.05h.44v165.82h-.44z"/><path fill="#fbe182" d="M1685.65-2.05h.44v165.82h-.44z"/><path fill="#fbe283" d="M1686.09-2.05h.44v165.82h-.44z"/><path fill="#fbe384" d="M1686.53-2.05h.44v165.82h-.44z"/><path fill="#fce385" d="M1686.97-2.05h.44v165.82h-.44z"/><path fill="#fce486" d="M1687.41-2.05h.44v165.82h-.44z"/><path fill="#fce587" d="M1687.85-2.05h.44v165.82h-.44z"/><path fill="#fce588" d="M1688.29-2.05h.44v165.82h-.44z"/><path fill="#fce689" d="M1688.73-2.05h.44v165.82h-.44z"/><path fill="#fde78a" d="M1689.17-2.05h.44v165.82h-.44z"/><path fill="#fde78b" d="M1689.61-2.05h.44v165.82h-.44z"/><path fill="#fde88d" d="M1690.05-2.05h.44v165.82h-.44z"/><path fill="#fde98e" d="M1690.49-2.05h.44v165.82h-.44z"/><path fill="#fde98f" d="M1690.93-2.05h.44v165.82h-.44z"/><path fill="#feea90" d="M1691.37-2.05h.44v165.82h-.44z"/><path fill="#feea91" d="M1691.82-2.05h.44v165.82h-.44z"/><path fill="#feeb91" d="M1692.26-2.05h.44v165.82h-.44z"/><path fill="#feec92" d="M1692.7-2.05h.44v165.82h-.44z"/><path fill="#feec93" d="M1693.14-2.05h.44v165.82h-.44z"/><path fill="#feed94" d="M1693.58-2.05h.44v165.82h-.44z"/><path class="cls-111" d="M1694.02-2.05h.44v165.82h-.44z"/><path fill="#ffee96" d="M1694.46-2.05h.44v165.82h-.44z"/><path class="cls-107" d="M1694.9-2.05h.44v165.82h-.44z"/><path class="cls-107" d="M1695.34-2.05h.72v165.82h-.72z"/><path fill="#ffed96" d="M1696.06-2.05h.72v165.82h-.72z"/><path class="cls-111" d="M1696.77-2.05h.72v165.82h-.72z"/><path fill="#feec94" d="M1697.5-2.05h.72v165.82h-.72z"/><path class="cls-139" d="M1698.21-2.05h.72v165.82h-.72zM1698.93-2.05h.72v165.82h-.72z"/><path fill="#feea92" d="M1699.64-2.05h.72v165.82h-.72z"/><path fill="#fee991" d="M1700.37-2.05h.72v165.82h-.72z"/><path fill="#fee890" d="M1701.08-2.05h.72v165.82h-.72z"/><path fill="#fee88f" d="M1701.8-2.05h.72v165.82h-.72z"/><path fill="#fde78f" d="M1702.51-2.05h.72v165.82h-.72z"/><path fill="#fde68e" d="M1703.23-2.05h.72v165.82h-.72z"/><path fill="#fde58d" d="M1703.96-2.05h.72v165.82h-.72z"/><path fill="#fde58c" d="M1704.67-2.05h.72v165.82h-.72z"/><path fill="#fde48b" d="M1705.39-2.05h.72v165.82h-.72z"/><path fill="#fde38a" d="M1706.1-2.05h.72v165.82h-.72z"/><path fill="#fce28a" d="M1706.83-2.05h.72v165.82h-.72z"/><path fill="#fce289" d="M1707.54-2.05h.72v165.82h-.72z"/><path fill="#fce188" d="M1708.26-2.05h.72v165.82h-.72z"/><path fill="#fce087" d="M1708.97-2.05h.72v165.82h-.72z"/><path fill="#fce086" d="M1709.69-2.05h.72v165.82h-.72z"/><path fill="#fcdf86" d="M1710.41-2.05h.72v165.82h-.72z"/><path fill="#fcde85" d="M1711.13-2.05h.72v165.82h-.72z"/><path fill="#fbdd84" d="M1711.84-2.05h.72v165.82h-.72z"/><path fill="#fbdd83" d="M1712.56-2.05h.72v165.82h-.72z"/><path fill="#fbdc82" d="M1713.28-2.05h.72v165.82h-.72z"/><path fill="#fbdb82" d="M1714-2.05h.72v165.82h-.72z"/><path fill="#fbda81" d="M1714.72-2.05h.72v165.82h-.72z"/><path fill="#fbda80" d="M1715.43-2.05h.72v165.82h-.72z"/><path fill="#fad97f" d="M1716.15-2.05h.72v165.82h-.72z"/><path fill="#fad87e" d="M1716.87-2.05h.72v165.82h-.72z"/><path fill="#fad87d" d="M1717.59-2.05h.72v165.82h-.72z"/><path fill="#fad77d" d="M1718.3-2.05h.72v165.82h-.72z"/><path fill="#fad67c" d="M1719.02-2.05h.72v165.82h-.72z"/><path fill="#fad57b" d="M1719.73-2.05h.72v165.82h-.72z"/><path fill="#f9d57a" d="M1720.46-2.05h.72v165.82h-.72z"/><path fill="#f9d479" d="M1721.17-2.05h.72v165.82h-.72z"/><path fill="#f9d379" d="M1721.89-2.05h.72v165.82h-.72z"/><path fill="#f9d278" d="M1722.61-2.05h.72v165.82h-.72z"/><path fill="#f9d277" d="M1723.33-2.05h.72v165.82h-.72z"/><path fill="#f9d176" d="M1724.05-2.05h.72v165.82h-.72z"/><path fill="#f8d075" d="M1724.76-2.05h.72v165.82h-.72z"/><path fill="#f8cf74" d="M1725.48-2.05h.72v165.82h-.72z"/><path fill="#f8ce74" d="M1726.19-2.05h.72v165.82h-.72z"/><path fill="#f8ce73" d="M1726.92-2.05h.72v165.82h-.72z"/><path fill="#f8cd72" d="M1727.63-2.05h.72v165.82h-.72z"/><path fill="#f8cc71" d="M1728.35-2.05h.72v165.82h-.72z"/><path fill="#f7cb71" d="M1729.06-2.05h.72v165.82h-.72z"/><path fill="#f7cb70" d="M1729.78-2.05h.72v165.82h-.72z"/><path fill="#f7ca6f" d="M1730.5-2.05h.72v165.82h-.72z"/><path fill="#f7c96e" d="M1731.22-2.05h.72v165.82h-.72z"/><path fill="#f7c86d" d="M1731.94-2.05h.72v165.82h-.72z"/><path fill="#f6c86c" d="M1732.65-2.05h.72v165.82h-.72z"/><path fill="#f6c76c" d="M1733.38-2.05h.72v165.82h-.72z"/><path fill="#f6c66b" d="M1734.09-2.05h.72v165.82h-.72z"/><path fill="#f6c56a" d="M1734.81-2.05h.72v165.82h-.72z"/><path fill="#f6c469" d="M1735.52-2.05h.72v165.82h-.72z"/><path fill="#f6c468" d="M1736.24-2.05h.72v165.82h-.72z"/><path fill="#f5c368" d="M1736.96-2.05h.72v165.82h-.72z"/><path fill="#f5c267" d="M1737.68-2.05h.72v165.82h-.72z"/><path fill="#f5c166" d="M1738.39-2.05h.72v165.82h-.72z"/><path fill="#f5c165" d="M1739.11-2.05h.72v165.82h-.72z"/><path fill="#f5c064" d="M1739.84-2.05h.72v165.82h-.72z"/><path fill="#f5bf64" d="M1740.55-2.05h.72v165.82h-.72z"/><path fill="#f4be63" d="M1741.27-2.05h.72v165.82h-.72z"/><path fill="#f4bd62" d="M1741.98-2.05h.72v165.82h-.72z"/><path fill="#f4bd61" d="M1742.7-2.05h.72v165.82h-.72z"/><path fill="#f4bc61" d="M1743.42-2.05h.72v165.82h-.72z"/><path fill="#f4bb60" d="M1744.14-2.05h.72v165.82h-.72z"/><path fill="#f4ba5f" d="M1744.85-2.05h.72v165.82h-.72z"/><path fill="#f3b95e" d="M1745.57-2.05h.72v165.82h-.72z"/><path fill="#f3b95d" d="M1746.29-2.05h.72v165.82h-.72z"/><path fill="#f3b85d" d="M1747.01-2.05h.72v165.82h-.72z"/><path fill="#f3b75c" d="M1747.72-2.05h.72v165.82h-.72z"/><path fill="#f3b65b" d="M1748.44-2.05h.72v165.82h-.72z"/><path class="cls-124" d="M1749.16-2.05h.72v165.82h-.72zM1749.88-2.05h.72v165.82h-.72z"/><path fill="#f2b459" d="M1750.6-2.05h.72v165.82h-.72z"/><path fill="#f2b358" d="M1751.31-2.05h.72v165.82h-.72z"/><path fill="#f2b257" d="M1752.03-2.05h.72v165.82h-.72z"/><path class="cls-85" d="M1752.74-2.05h.72v165.82h-.72zM1753.47-2.05h.72v165.82h-.72z"/><path fill="#f1b055" d="M1754.18-2.05h.72v165.82h-.72z"/><path fill="#f1af54" d="M1754.9-2.05h.72v165.82h-.72z"/><path fill="#f1ae53" d="M1755.61-2.05h.72v165.82h-.72z"/><path fill="#f1ad53" d="M1756.34-2.05h.72v165.82h-.72z"/><path fill="#f0ad52" d="M1757.05-2.05h.72v165.82h-.72z"/><path fill="#f0ac51" d="M1757.77-2.05h.72v165.82h-.72z"/><path fill="#f0ab50" d="M1758.49-2.05h.72v165.82h-.72z"/><path fill="#f0aa4f" d="M1759.2-2.05h.72v165.82h-.72z"/><path fill="#f0a94f" d="M1759.93-2.05h.72v165.82h-.72z"/><path fill="#efa84e" d="M1760.64-2.05h.72v165.82h-.72z"/><path fill="#efa84d" d="M1761.36-2.05h.72v165.82h-.72z"/><path class="cls-65" d="M1762.07-2.05h.72v165.82h-.72z"/><path class="cls-63" d="M1762.8-2.05h.72v165.82h-.72z"/><path class="cls-63" d="M1763.51-2.05h1.34v165.82h-1.34z"/><path class="cls-65" d="M1764.86-2.05h1.34v165.82h-1.34zM1766.2-2.05h1.34v165.82h-1.34z"/><path fill="#efa84b" d="M1767.54-2.05h1.34v165.82h-1.34z"/><path fill="#efa94b" d="M1768.89-2.05h1.34v165.82h-1.34z"/><path class="cls-163" d="M1770.23-2.05h1.34v165.82h-1.34zM1771.57-2.05h1.34v165.82h-1.34z"/><path fill="#efab4b" d="M1772.92-2.05h1.34v165.82h-1.34z"/><path class="cls-64" d="M1774.26-2.05h1.34v165.82h-1.34zM1775.6-2.05h1.34v165.82h-1.34z"/><path fill="#efad4b" d="M1776.95-2.05h1.34v165.82h-1.34z"/><path fill="#efae4b" d="M1778.29-2.05h1.34v165.82h-1.34z"/><path class="cls-67" d="M1779.64-2.05h1.34v165.82h-1.34zM1780.98-2.05h1.34v165.82h-1.34z"/><path fill="#efb04b" d="M1782.32-2.05h1.34v165.82h-1.34z"/><path class="cls-66" d="M1783.67-2.05h1.34v165.82h-1.34zM1785.01-2.05h1.34v165.82h-1.34z"/><path fill="#efb24b" d="M1786.35-2.05h1.34v165.82h-1.34z"/><path class="cls-71" d="M1787.7-2.05h1.34v165.82h-1.34zM1789.05-2.05h1.34v165.82h-1.34z"/><path fill="#efb44a" d="M1790.39-2.05h1.34v165.82h-1.34z"/><path class="cls-60" d="M1791.74-2.05h1.34v165.82h-1.34zM1793.08-2.05h1.34v165.82h-1.34z"/><path fill="#efb64a" d="M1794.42-2.05h1.34v165.82h-1.34z"/><path class="cls-61" d="M1795.77-2.05h1.34v165.82h-1.34zM1797.11-2.05h1.34v165.82h-1.34z"/><path fill="#efb84a" d="M1798.45-2.05h1.34v165.82h-1.34z"/><path class="cls-69" d="M1799.8-2.05h1.34v165.82h-1.34zM1801.14-2.05h1.34v165.82h-1.34z"/><path fill="#efba49" d="M1802.48-2.05h1.34v165.82h-1.34z"/><path class="cls-59" d="M1803.83-2.05h1.34v165.82h-1.34zM1805.17-2.05h1.34v165.82h-1.34z"/><path fill="#efbc49" d="M1806.51-2.05h1.34v165.82h-1.34z"/><path class="cls-119" d="M1807.86-2.05h1.34v165.82h-1.34zM1809.2-2.05h1.34v165.82h-1.34z"/><path class="cls-121" d="M1810.54-2.05h1.34v165.82h-1.34zM1811.89-2.05h1.34v165.82h-1.34z"/></g></svg>`,
            getProductPricesDebounced: this.debounce(this.getProductPrices, 250),
            userFavorites: [],
            loading: false,
        };
    },
    
    created() {
        this.initFilters()
        // Add Algolia userToken for Algolia Insights
        searchInsights('setUserToken', this.algoliaUserToken);
        window.addEventListener("scroll", this.onWindowScroll);
        window.addEventListener('resize', this.onWindowResize);
        // Run this once to be sure grid-view is set on mobile
        this.onWindowResize()
    },
    
    beforeDestroy() {
        window.removeEventListener("scroll", this.onWindowScroll);
    },
    
    mounted() {
        // Empty current products for certainty
        this.productsInOrder = []
        
        // Disable pricingAPI when not logged in (prices are hidden then) or when forced to be turned off
        if (!this.forceDisablePricingAPI) {
            this.enablePricingAPI = !!this.loggedIn
        } else {
            this.enablePricingAPI = false
        }
        
        if (this.directOrder) {
            // Show products that are in the cart
            this.$store.dispatch('loadCart').then(result => {
                if (result && result.lineItems) this.productsInOrder = this.mapLineItemsToProducts(result.lineItems)
            });
        } else {
            // Show products that are in a saved order
            if (this.productsInCurrentOrder.length) this.productsInOrder = this.productsInCurrentOrder
        }
        
        if (this.inSalesApp && this.user.salesEmail !== "Dirk.Aben@ranson.be") {
            const webshopEl = document.getElementById('webshop--wrapper')
            webshopEl.classList.add('webshop--sticky')
        }

        this.userFavorites = this.favoriteProductIds
    },
    
    watch: {
        qtyFocusId: function (id) {
            // We stop the Pricing API fetch when qty input has focus or is active
            const targetHasFocus = this.qtyFocusId && (this.qtyFocusId === id || document.activeElement.id === id)
            if (!targetHasFocus) {
                clearTimeout(this.qtyUpdateTimeout)
                this.qtyUpdateTimeout = setTimeout(() => {
                    this.getProductPrices()
                }, 500)
            }
        },
        loading: function(val) {
            if(val) {
                // Get all buttons and disable them
                const buttons = document.querySelectorAll('button.btn-cart')
                buttons.forEach(el => {
                    el.disabled = true
                })
            } else {
                // Get all buttons and enable them
                const buttons = document.querySelectorAll('button.btn-cart')
                buttons.forEach(el => {
                    el.disabled = false
                })
            }
        }
    },
    
    methods: {
        debounceAlgoliaSearch(refine, input, delay = 100) {
            clearTimeout(this.debounceSearchTimer);
            this.debounceSearchTimer = setTimeout(() => {
                refine(input);
            }, delay);
        },
        
        toggleFilterPanel() {
            this.showFilterPanel = !this.showFilterPanel;
            this.showFilterPanel ? disableBodyScroll(this.$refs.filterPanel) : enableBodyScroll(this.$refs.filterPanel);
        },
        
        onWindowScroll() {
            // Reset focus on qty input on scroll -> restarts pricing API fetch
            this.qtyFocusId = null
        },

      onWindowResize() {
        // Set to grid view for smaller screen sizes
        if(window.innerWidth <= 1023) {
          this.$store.dispatch('setAlgoliaView', 'grid-view')
        }
      },
        
        initShowAllProducts() {
            this.showAllProducts = true;
            this.showFavorites = false;
        },
        
        getProductPrices() {
            /*
             * If we restart the prices queue somewhere, chances are the items in the productPrices array have changed.
             * E.g. This happens when we change filters in Algolia, then we add the new products to the top of the productPrices array
             * as we need to fetch these product prices first before the older products in the array that are not visible anymore.
             * Hence we destroy the current queue and rebuild it from the newly sorted productPrices array.
             *
             */
            if (checkQueue('prices').total > 0) {
                if(!this.static) {
                  destroyQueue('prices')
                    .then(() => {
                      // The queue is dead, long live the queue
                      this.createProductPricesQueue()
                    })
                    .catch(error => {
                      console.error("Could not destroy pricing queue", error);
                    })
                } else {
                    this.createProductPricesQueue();
                }
            } else {
                this.createProductPricesQueue()
            }
        },
        
        createProductPricesQueue() {
            // Create queue
            createQueue('prices', {
                concurrent: 3,
                fetchOptions: {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': window.csrfToken
                    }
                }
            })
            
            const productsNotFetchedYet = this.productPrices.filter(product => !product.priceFetched)
            productsNotFetchedYet.forEach(product => {
                // We set a flag because when Algolia inits search widget multiple times, we only get the price once -> force to false if we need to update the price
                if (!product.priceFetched) {
                    this.getProductPrice(product, product.qty, 'prices')
                }
            })
        },
        
        transformItems(items) {
            // Reverse items -> lets us unshift the products correctly into the productPrices array
            items.reverse()
            
            // Keep count of the mapped items to know when the transform has finished
            let i = 0;
            
            const alteredItems = items.map(item => {
                i += 1
                /* Fill object with info to show default price at first and gather correct prices afterwards
                 * -> we do it afterwards, instead of during the transform, so we don't delay anything unnecessarily
                 * Algolia inits search widget multiple times, so we only add the items once.
                 * Setting a flag once for all does not work as the transform-items also needs to be called when filtering or paginating.
                 */

                const product = {
                    productId: item.objectID,
                    sku: item.sku,
                    defaultPrice: item.defaultPrice,
                    priceFetched: false,
                    qty: this.getMinQty(item.multiples)
                }
                
                if (!this.productPrices.find(product => product.productId === item.objectID)) {
                    this.productPrices.unshift(product)
                    //this.getProductPrice(product) -> not used anymore as we cannot control queue sorting this way
                }
                
                // Check if item is a bestB product
                const bestBItem = this.showBestBProducts.find(product => parseInt(product.productId) === parseInt(item.objectID))
                
                // Start fetch prices
                if (i === items.length) {
                    this.getProductPricesDebounced();
                }
                
                // Dev-mode only
                if (window.isDevMode && item.images != null && item.images[0] && !item.images[0].startsWith('http')) item.images[0] = 'https://www.ranson.be' + item.images[0];
                
                return {
                    ...item,
                    url: this.setSalesAppUri(this.inSalesApp, this.inKioskApp, item.url),
                    qtyPreceding: bestBItem ? parseInt(bestBItem.quantityPreceding) : null,
                    qtyLast: bestBItem ? parseInt(bestBItem.quantityLast) : null,
                    lastOrderDate: bestBItem && bestBItem.lastOrderDate ? new Date(bestBItem.lastOrderDate.replace(/-/g, "/")) : null,
                    lastSellingPrice: bestBItem && bestBItem.lastSellingPrice ? bestBItem.lastSellingPrice : null,
                }
            })
            
            return alteredItems.reverse() // Reverse back for correct Algolia sorting
        },
        
        relabelCategories(items) {
            items.forEach(item => {
                if (item.label) item.label = item.label.substr(9);
                if (item.data && item.data.length) this.relabelCategories(item.data);
            })
            return items;
        },
        
        transformCurrentRefinements(refinement) {
            let label = refinement.label
            if (refinement?.attribute.startsWith("categories")) {
                const labelParts = refinement.label.split(" > ")
                let newLabelParts = []
                labelParts.forEach(label => {
                    newLabelParts.push(label.substr(9))
                })
                label = newLabelParts.join(" > ")
            }
            
            if (refinement.type === 'numeric') label = refinement.attribute + " " + label
            if (refinement?.attribute === 'bio') label = refinement.attribute
            if (refinement?.attribute === 'themes') label = refinement.label.split("|")[0]
            if (refinement?.attribute === 'privateLabel') label = window.i18n.t("Private label")
            if (refinement?.attribute === 'bargainSale') label = window.i18n.t("bargainSale")
            
            return window.i18n.t(label)
        },
        
        transformFilters(items) {
            console.log(items);
            return items.map(item => ({
                ...item,
                label: window.i18n.t(item.label),
            }));
        },

        transformFiltersBakingTypes(items) {
            return items.map(item => (
                this.setBakingTypeLabelIcon(item)
            ));
        },

        setBakingTypeLabelIcon(item) {
            if(item.label !== 'None') {
                const icon = item.label.toLowerCase();
                const label = window.i18n.t(item.label);
                let newLabel = false;
                const array = label.replace('–','-').split('-');
                if(array.length >= 1) {
                    newLabel = array[1];
                }
                return {
                    ...item,
                    label: newLabel,
                    icon: window.i18n.t(icon)
                }
            } else {
                return item;
            }
        },
        
        transformThemes(items) {
            /* READ ME
             * We don't limit the amount of items of the themes list as we only get the visible items from Algolia as arguments
             * for this widget's functions. Ideally we would add this code not in the transform but inside the sort-by function.
             * The sort-by function acts as a custom sort() which only passes 2 items as arguments by default. This restricts us
             * from sorting the dates as we want (we need to sort by 3 dates, itemA, itemB and current date which cannot be done
             * inside a single sort()).
             * When we limit the widgets items, items are hidden according to the sort-by function (by default that is hit count).
             * As we never receive all items from Algolia, we cannot sort them correctly and the wrong items are hidden.
             * Because in this case, we want to hide the last items only as those are holidays the longest ago.
             * The widget also return only the visible items in the transform function. But that is called every time so
             * it is less of a problem here.
             */
            
            /* We normalize dates to the year 2020, so we can compare recurring dates without
             * needing to edit the dates in the CMS every time they are over.
             * 2020 was a leap year so every possible date should be able to parse without errors.
             */
            
            // Normalized date
            const nowDate = new Date(new Date().setFullYear(2020));
            const nowTimestamp = Math.ceil(nowDate.getTime() / 1000);
            
            /* item.label is e.g. "Moederdag|0123456789" -> Label|UnixTimestamp
             * So we extract the proper label and the unix timestamp to sort by from it and add it to the item object.
             */
            const mappedItems = items.map(item => {
                // Get correct label
                const itemLabel = item.label.split("|")[0];
                
                // Get timestamp
                const itemTimestamp = item.label.split("|")[1];
                // Convert timestamp to real date
                const date = new Date(itemTimestamp * 1000);
                // Normalize dates to the year 2020
                const normalizedDate = new Date(date.setFullYear(2020));
                // Convert back to timestamp
                const normalizedTimestamp = Math.ceil(normalizedDate.getTime() / 1000);
                
                return {
                    ...item,
                    // Set timestamp
                    timestamp: normalizedTimestamp,
                    // Set correct label
                    label: itemLabel
                }
            });
            
            // Sort the items by the timestamp
            mappedItems.sort((a, b) => {
                return a.timestamp - b.timestamp
            })
            
            // Put all items with a date after now on top and all items with a date before now at the bottom of the array
            return [...mappedItems.filter(item => item.timestamp > nowTimestamp), ...mappedItems.filter(item => item.timestamp < nowTimestamp)]
        },
        
        sortFilters(a, b) {
            // Set 'NA/None' at the end -> other sorting won't go as titles get translated on the frontend!
            if (a.name === "None") return 1
            return -1
        },
        
        getAlternativeProducts(id) {
            // No user facing error messages, because we don't want to stop the order if there is a POSSIBLE alternative issue
            const inventSiteId = this.user?.inventSiteId ?? '01' // 01 = default warehouse
            
            return window.axios({
                url: `${ window.rootUrl }api/product/alternatives/${ id }.json?inventSiteId=${ inventSiteId }`,
                method: 'GET'
            }).then(result => {
                if (result.status === 200 && result?.data?.alternatives) {
                    return result.data.alternatives
                } else {
                    console.error("Could not retrieve alternative products.", error);
                    return null
                }
            }).catch((error) => {
                console.error("Could not retrieve alternative products.", error);
                return null
            });
        },
        
        async checkForAlternatives(algoliaProduct) {
            const productAlternatives = await this.getAlternativeProducts(algoliaProduct.objectID)
                .then(data => data)
                .catch(error => {
                    console.error("Error while fetching product alternatives.", error)
                    return null
                })
            
            if (productAlternatives && productAlternatives.length) {
                // Get chosen quantity -> if it was already changed the product will be in the productOrder list else we order 1
                const product = this.isProductInOrder(algoliaProduct.objectID)
                const qty = product ? product.qty : 1
                
                // Alternatives found
                await this.$store.dispatch(
                    'toggleModal',
                    {
                        name: 'alternatives',
                        data: {
                            alternatives: productAlternatives.map(a => a.product),
                            isSales: this.isSales,
                            directOrder: this.directOrder,
                            chosenQuantity: qty
                        }
                    }
                )
                
                return false
            } else if (productAlternatives) {
                return true
            } else {
                // Error occurred (productAlternatives is null)
                this.$notify({
                    title: window.i18n.t("errors.generalTitle"),
                    text: window.i18n.t("errors.notAddedToCart"),
                    type: "error"
                });
                console.error("Error while fetching product alternatives.")
                
                return false
            }
        },
        
        addProductToCart(e, algoliaProduct, callbackFn) {
            this.loading = true
            this.addingToCart = algoliaProduct.objectID
            // Set right qty on product
            const form = e.target.closest('form')
            const qtyInput = form.querySelector('.qty')
            algoliaProduct.qty = qtyInput.value
            // Cancel current requests
            killQueue('prices')
            this.checkForAlternatives(algoliaProduct).then(result => {
                if (result) this.addToCart(algoliaProduct, callbackFn)
            })
        },
        
        addProductToOrder(algoliaProduct) {
            this.addingToCart = algoliaProduct.objectID
            killQueue('prices')
            this.checkForAlternatives(algoliaProduct).then(result => {
                if (result) this.addToOrder(algoliaProduct)
            })
        },
        
        addProductToCartModal(algoliaProduct) {
            this.addingToCartModal = algoliaProduct.objectID
            killQueue('prices')
            this.checkForAlternatives(algoliaProduct).then(result => {
                if (result) this.addToCartModal(algoliaProduct)
            })
        },
        
        loadCart(lineItems) {
            // Used within addToCartModal, if a product is added to the cart there, we need to update the list here
            this.productsInOrder = this.mapLineItemsToProducts(lineItems)
        },
        
        addToCart(currentProduct, callbackFn) {
            // Check if product is already added by changing the quantity, if not, add it to the list
            let product = this.isProductInOrder(currentProduct.objectID) ?? this.addToOrder(currentProduct, currentProduct.qty)
            
            if (product) {
                // Check if there is an updated price available
                const productInProductPrices = this.productPrices.find(product => product.productId === currentProduct.objectID)
                const price = productInProductPrices ? productInProductPrices.defaultPrice : currentProduct.defaultPrice
                
                window.axios({
                    url: `${ window.rootUrl }actions/commerce/cart/update-cart`,
                    method: 'POST',
                    data: {
                        purchasableId: product.purchasableId,
                        qty: product.qty,
                    }
                }).then(result => {
                    if (result.status === 200) {
                        // Show notification
                        this.$notify({
                            text: window.i18n.t("success.addedToCart"),
                            type: "success",
                        });
                        
                        // Save cart
                        if (result?.data?.cart) {
                            this.$store.dispatch('saveCart', result.data.cart);
                        }
                        
                        // Show highlight products in cart
                        if (result?.data?.cart?.lineItems) {
                            const lineItems = result.data.cart.lineItems;
                            this.productsInOrder = this.mapLineItemsToProducts(lineItems)
                            const productUpdated = lineItems.find(product => product.purchasableId === product.purchasableId)
                            callbackFn(productUpdated.qty)
                        }
                        
                        // Send Algolia event
                        this.$refs.aisHits.state.sendEvent('conversion', currentProduct, 'Product added to cart.');

                        this.loading = false

                    } else {
                        this.$notify({
                            title: window.i18n.t("errors.generalTitle"),
                            text: window.i18n.t("errors.notAddedToCart"),
                            type: "error",
                        });
                        console.error("Cart error.", result);

                        this.loading = false
                    }
                }).catch((error) => {
                    this.$notify({
                        title: window.i18n.t("errors.generalTitle"),
                        text: window.i18n.t("errors.cartNotUpdated"),
                        type: "error",
                    });
                    console.error("Cart error.", error);

                    this.loading = false;
                }).finally(() => {
                    // Restart canceled price info
                    this.getProductPrices();
                    this.addingToCart = false;
                    this.loading = false;
                });
            }
        },
        
        addToOrder(currentProduct, quantity) {
            let id = currentProduct.hasOwnProperty('objectID') ? currentProduct.objectID : currentProduct.id
            const product = {
                rowId: null,
                id: parseInt(id),
                purchasableId: parseInt(currentProduct.purchasableId),
                title: currentProduct.title,
                defaultPrice: currentProduct.defaultPrice,
                qty: quantity ?? currentProduct.qty ?? 1,
                type: currentProduct.type ?? '',
                data: currentProduct
            }
            
            // Products from alternative modal have type == saved
            if (!this.isProductInOrder(parseInt(id))) {
                /* Product not in array: 2 possibilities
                 * 1: Add button clicked with qty == 1 -> set saved type
                 * 2: Quantity changed -> qty always > 1 -> not yet saved -> don't set type
                 * 3: Alternative with higher quantity saved -> type is already 'saved'
                 */
                if (product.qty === 1) product.type = 'saved'
                this.productsInOrder.push(product);
            } else {
                // Product already in order -> get product, set it to saved and adjust quantity
                let existingProduct = this.isProductInOrder(parseInt(id))
                existingProduct.type = 'saved'
                existingProduct.qty += product.qty
            }
            
            this.$emit('update-order', this.productsInOrder)
            
            this.addingToCart = false
            
            // Restart canceled price info -> enkel indien geen directOrder want anders wordt het MOGELIJKS al vroeger getriggered in addToCart
            if (!this.directOrder) {
                this.getProductPrices();
            }
            
            return product
        },
        
        removeProductFromOrder(id) {
            const index = this.productsInOrder.findIndex(product => parseInt(product.id) === parseInt(id));
            if (index > -1) this.productsInOrder.splice(index, 1);
            this.$emit('update-order', this.productsInOrder)
        },
        
        addToCartModal(item) {
            const product = this.isProductInOrder(item.objectID)
            
            const addToCartProduct = {
                sku: item.sku,
                purchasableId: item.purchasableId,
                qty: product ? product.qty : 1,
                defaultPrice: item.defaultPrice ?? 0,
                multiples: item.multiples
            }
            
            this.$store.dispatch('toggleModal', { name: 'addToCart', data: addToCartProduct }).then(() => {
                this.addingToCartModal = false;
                this.getProductPrices();
            });
        },
        
        getProductQty(id, multiples) {
            const product = this.isProductInOrder(id)
            if (product) return product.qty
            if (multiples) {
                // Check if customer is linked to one of the inventSiteId's
                // in the object
                const inventSiteId = this.user?.inventSiteId ?? ''
                
                const specificMultiple = multiples.filter(el => el.inventSiteId == inventSiteId)
                const globalMultiple = multiples.filter(el => el.inventSiteId == '' || el.inventSiteId == null)
                
                if (specificMultiple.length) {
                    return (specificMultiple[0].lowestQty > 0) ? specificMultiple[0].lowestQty : 1
                }
                
                if (globalMultiple.length) {
                    return (globalMultiple[0].lowestQty > 0) ? globalMultiple[0].lowestQty : 1
                }
            }
            return 1
        },
        
        toggleQtyFocus(elementId) {
            destroyQueue('prices')
            this.qtyFocusId = elementId
        },
        
        updateQty(e, currentProduct, quantity) {

            this.toggleQtyFocus(e.target.id)

            const qty = e ? parseInt(e.target.value) : quantity;

            //destroyQueue('pricesQty')

            let id = currentProduct.hasOwnProperty('objectID') ? currentProduct.objectID : currentProduct.id
            // First get the form
            const form = e.target.closest('form')
            // Now get the buttons in the form
            const buttons = form.querySelectorAll('button')

            // Check for mandatory multiples
            if (currentProduct.multiples && qty) {

                let step = parseInt(e.target.step)
                let min = parseInt(e.target.min)

                if (qty < min) {
                    this.$notify({
                        text: window.i18n.t("errors.minQtyError", { min }),
                        type: "error",
                    });

                    // Disable buttons
                    buttons.forEach(el => {
                        el.disabled = true
                    })

                    return false;
                }

                if (qty % step !== 0) {
                    this.$notify({
                        text: window.i18n.t("errors.stepQtyError", { step }),
                        type: "error",
                    });

                    // Disable buttons
                    buttons.forEach(el => {
                        el.disabled = true
                    })

                    return false;
                }
            }

            if (e.target.value) {
                // Get new price with qty
                // Create queue
                createQueue('pricesQty', {
                    concurrent: 3,
                    fetchOptions: {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': window.csrfToken
                        }
                    }
                })

                // Send right product data to function
                let productData = this.productPrices.find(product => product.productId === id)
                // Set price fetched to false
                productData.priceFetched = false
                //
                this.getProductPrice(productData, qty, 'pricesQty')
            }

            // Enabled buttons
            // Disable buttons
            buttons.forEach(el => {
                el.removeAttribute('disabled')
            })
        },

        getProductPrice(product, qty, queueName) {
            if (!this.enablePricingAPI) {
                if (this.inKioskApp) product.priceFetched = true
                return product.defaultPrice
            }

            if (product && !product.priceFetched) {
                fetchQueue('/actions/ranson-module/customer/price', {
                    method: 'POST',
                    body: JSON.stringify({
                        useDb: true,
                        itemId: product.sku,
                        customer: this.user.id ?? null,
                        qty: qty,
                        requestedDeliveryDate: null
                    }),
                }, queueName)
                .then(response => {
                    if (!response.ok) throw new Error("HTTP error " + response.status);
                    return response.json();
                })
                .then(response => {
                    if (response.price !== null || response.price !== "undefined") {
                        product.defaultPrice = response.price
                        product.priceFetched = true
                        product.volumeDiscounts = response.volumeDiscounts
                    }
                })
                .catch(error => {
                    console.warn("Couldn't fetch price", error)
                })
            }
        },
        
        isProductInOrder(id) {
            return this.productsInOrder.find(product => parseInt(product.id) === parseInt(id))
        },

        mapLineItemsToProducts(lineItems) {
            return lineItems.map(lineItem => {
                return {
                    rowId: null,
                    id: parseInt(lineItem.snapshot.product.id),
                    purchasableId: parseInt(lineItem.purchasableId),
                    title: lineItem.description,
                    defaultPrice: lineItem.price,
                    qty: lineItem.qty, // Always start from quantity 1 for items in cart
                    type: 'lineItem' // Used to differentiate between order products and lineItems for highlighting correct products depending on directOrder
                }
            });
        },
        
        initFilters(refine) {
            /* We use initFilters to set the pre-filtering on first load.
             * Afterward, the client can filter what he wants and those filters will be persistent.
             * We create a flag for this and save it to localStorage: initFiltersSet.
             * If this flag exists, we do not reset the clients filters.
             *
             * If the reset button is clicked we only want to reset to the initial custom filters.
             * !!! We do not reset back to the initialUiState as this would prevent the client from choosing different facet filters.
             * We do a reset by removing the uid from the initFilterSet so the next line of code will execute and the custom filters are re-saved.
             */
            if (refine) this.$store.dispatch('toggleInitFiltersSet', this.uid)
            
            if (!this.$store.getters.getInitFiltersSet(this.uid)) {
                this.customFilters = [];
                if (this.obProducts) this.customFilters.push('ob');
                if (this.newProducts) this.customFilters.push('new');
                if (this.promoProducts) this.customFilters.push('promo');
                if (this.utz) this.customFilters.push('utz');
                if (this.fairtrade) this.customFilters.push('fairtrade');
                if (this.bargainSale) this.customFilters.push('bargainSale');
                
                this.$store.dispatch('toggleInitFiltersSet', this.uid)
            }
            
            // Reset custom brand filter
            this.brandFilter = null;
            
            if (refine) refine();
        },
        
        itemIsNew(item) {
            if (item.dateCreated) return new Date(item.dateCreated * 1000) > (new Date().setDate(new Date().getDate() - 30)) // 30 days ago from today
            return false
        },
        
        removeFromBestB(item) {
            // Fetch needs scope apparenlty
            const csrfToken = document.head.querySelector('meta[name="csrf-token"]')
            
            let postData = new FormData();
            postData.append('action', 'formie/submissions/submit')
            postData.append('handle', 'VerwijderUitBestBRapport')
            postData.append('siteId', 1)
            postData.append('CRAFT_CSRF_TOKEN', csrfToken.content)
            postData.append('fields[spocEmail]', this.user.spocEmail)
            postData.append('fields[sales]', this.user.sales)
            postData.append('fields[salesEmail]', this.user.salesEmail)
            postData.append('fields[accountNum]', this.user.accountNum)
            postData.append('fields[sku]', item.sku + " " + item.title)
            
            fetch('/', {
                method: 'POST',
                body: postData,
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }).then(response => {
                response.json().then(data => {
                    if (data.success) {
                        this.$notify({
                            text: window.i18n.t("success.removedFromBestB"),
                            type: "success",
                        });
                    } else {
                        this.$notify({
                            text: window.i18n.t("errors.removedFromBestB"),
                            type: "error",
                        });
                    }
                });
            })
        },
        
        brandClick(brand) {
            if (brand.brandPage) {
                window.location = brand.brandPage
            } else {
                this.brandFilter = brand.category
            }
        },
        
        priceFetched(id) {
            const productInProductPrices = this.productPrices.find(product => product.productId === id)
            return productInProductPrices && productInProductPrices.priceFetched
        },
        
        defaultPrice(id) {
            const productInProductPrices = this.productPrices.find(product => product.productId === id)
            if (productInProductPrices && productInProductPrices.defaultPrice) return this.formatCurrency(productInProductPrices.defaultPrice);
            return null
        },

        currentQty(id) {
            const productInProductPrices = this.productsInOrder.find(product => parseInt(product.id) === parseInt(id))
            if (productInProductPrices && productInProductPrices.qty) return productInProductPrices.qty.toString();
            return "1"
        },

        volumeDiscounts(id) {
            const productInProductPrices = this.productPrices.find(product => product.productId === id)
            if (productInProductPrices && productInProductPrices.volumeDiscounts) return productInProductPrices.volumeDiscounts;
            return []
        },
        
        pageChange() {
            document.body.scrollIntoView()
        },
        
        toggleCustomFilter(filter) {
            if (this.customFilters.includes(filter)) {
                let newFilters = [...this.customFilters]
                const filterIndex = newFilters.findIndex(f => f === filter)
                newFilters.splice(filterIndex, 1)
                this.$store.dispatch('saveCustomFilters', newFilters)
            } else {
                this.$store.dispatch('saveCustomFilters', [...this.customFilters, filter])
            }
        },
        
        toggleLegend() {
            this.legendActive = !this.legendActive
        },

        showPayByEmailModal(arg) {
            this.$emit('show-pay-by-email-modal', arg);
        }
    },
    
    computed: {
        ...mapState([
            'algoliaView',
            'algoliaUserToken'
        ]),
        
        indexName() {
            let sortId = ""
            if (this.sortingId && this.sortingId !== "") {
                sortId = "_" + this.sortingId // Load index sorted by chosen sortingId
            } else if (this.isSales) {
                sortId = "_sales" // Load index sorted for sales
            }
            
            return `products_${ window.language }${ sortId }` // Load sales index by default for sorting
        },
        
        initialUiState() {
            /* Only works with simple routing=true, in more advanced routing you have to set the initialUiState by routing itself.
             * This however returns a prop validation error but it still seems to work.
             */
            if (this.initUiState) return { [this.indexName]: this.initUiState }
            return {}
        },
        
        customFilters: {
            get: function () {
                return this.$store.state.customFilters
            },
            set: function (v) {
                this.$store.dispatch('saveCustomFilters', v)
            }
        },
        
        algoliaFilters() {
            /* Algolia AND/OR query operators
             * - customFilters = AND
             * - brandFilter = AND
             * - preFilters = AND
             * - bestB = AND (because we only want to see these products)
             * - privateLabel = OR
             */
            
            let filters = [];
            const showOb = this.customFilters.includes('ob')
            const showNew = this.customFilters.includes('new')
            const showPromo = this.customFilters.includes('promo')
            const showUtz = this.customFilters.includes('utz')
            const showFairtrade = this.customFilters.includes('fairtrade')
            const showBargainSale = this.customFilters.includes('bargainSale')
            const showSalesProducts = this.inSalesApp && this.isSales
            
            if (showOb) filters.push('ob:true')
            if (showNew) filters.push(`dateCreated > ${ new Date().setDate(new Date().getDate() - 30) / 1000 }`) // returns timestamp for Algolia in seconds
            if (showPromo) filters.push('promo:true')
            if (showUtz) filters.push('utz:true')
            if (showFairtrade) filters.push('fairtrade:true')
            if (showBargainSale) filters.push('bargainSale:true')
            
            if (this.brandFilter) {
                /*
                 // Filters by the deepest level
                 const brandFilterLvls = Object.entries(this.brandFilter)
                 const deepestLevel = brandFilterLvls[brandFilterLvls.length - 1]
                 filters.push(`brand.category.${ deepestLevel[0] }:"${ deepestLevel[1] }"`)
                 */
                
                // Filters by the main brand
                filters.push(`brand.category.lvl1:"${ this.brandFilter.lvl1 }"`)
            }
            
            // Categories or brand set as pre-filter inside the Twig template
            this.preFilters.forEach(preFilter => filters.push(preFilter))
            
            let productIds = [];
            if (this.showBestB) {
                this.showBestBProducts.forEach(product => {
                    productIds.push(`objectID:${ product.productId }`)
                })
            }

            if (this.showFavorites) {
                if(this.userFavorites.length) {
                    this.userFavorites.forEach(product => {
                        productIds.push(`objectID:${ product }`)
                    })
                } else {
                    return false;
                }
            }

            if (!this.showFavorites) {
              this.showPrivateLabelIds.forEach(id => {
                productIds.push(`objectID:${id}`)
              })
            }
            
            if (productIds.length) {
                productIds = productIds.join(' OR ')
                filters.push('(' + productIds + ')')
            }
            
            // Show only specific products
            if (this.showProductIds.length) {
                let productIds = [];
                this.showProductIds.forEach(id => {
                    productIds.push(`objectID:${ id }`)
                })
                productIds = productIds.join(' OR ')
                
                // If static view we always pass productIds, and we don't want other filters hiding certain products
                if (this.static) filters = []
                filters.push('(' + productIds + ')')
            }
            
            let filterArray = []
            
            // ADD products for normal filters
            if (filters.length) filterArray.push(filters.join(' AND '))
            
            // Combine all filters with OR
            let filterString = filterArray.join(' OR ')

            console.log(filterString)
            
            // Show privateFilters?
            if (!this.static) {
                if (showUtz || showFairtrade) {
                    if (filterString) filterString = filterString + ' OR ' // If filterString is empty Algolia throws an error due to AND/OR with only one query
                    filterString = filterString + 'privateLabel:true'
                } else if ((showOb || showPromo || showNew || showBargainSale || this.brandFilter || this.showProductIds.length)) {
                    if (filterString) {
                        if (productIds.length && !this.showBestB) {
                            filterString = filterString + ' OR '
                        } else {
                            filterString = filterString + ' AND '
                        }
                        filterString = filterString + 'privateLabel:false'
                    }
                } else if (!this.showBestB && !this.showFavorites) { // We don't want OR with brandFilters because else we filter by brand and also show all non-private labels.
                    if (filterString) filterString = filterString + ' OR ' // If filterString is empty Algolia throws an error due to AND/OR with only one query
                    filterString = filterString + 'privateLabel:false'
                }
                
                if (showSalesProducts && !this.showFavorites) {
                    /* If we're a sales manager, and we're in BestB,
                     * we don't want to see visibleToSales products
                     * but we do want to see BestB products that are visibleToSales only.
                     * Hence, we don't pass this filter, and show all BestB products (visibleToSales or not).
                     * For clients, we send the visibleToSales:false filter so these products will not be shown.
                     */
                    if(!this.showBestB) {
                        if (filterString) filterString = filterString + ' OR '
                        filterString = filterString + 'visibleToSales:true'
                    }
                    
                } else {
                    if (filterString) filterString = filterString + ' AND '
                    filterString = filterString + 'visibleToSales:false'
                }
            }
    
            // Discontinued products only need to be shown in BestB
            if (!this.showBestB) {
                if (filterString) filterString = filterString + ' AND ' // If filterString is empty Algolia throws an error due to AND/OR with only one query
                filterString = filterString + 'discontinued:false' // Hide discontinued products if we're not showing BestB
            }

            return filterString;
        },
        
        algoliaOptionalFilters() {
            // Focus assortment IDs are 'Ran[Channel name]'
            return [this.focusChannels.map(id => `focusAssortment:Ran${ id }`)]
        },
        
        currentYear() {
            return new Date().getFullYear()
        },
        
        previousYear() {
            return new Date().getFullYear() - 1;
        },
        
        savedOrCartProductIds() {
            return this.productsInOrder.filter(product => {
                if (this.directOrder && product.type === 'lineItem') return true
                if (!this.directOrder && product.type === 'saved') return true
            }).map(product => product.id)
        },
        
        showBestB() {
            return !!(!this.showAllProducts && !this.showFavorites && this.isBestB && this.showBestBProducts.length)
        }
    }
};
</script>

<style scoped>
.webshop--sticky .filters-panel,
.webshop--sticky .search-bar {
    @apply md:sticky bg-white;
    @screen md {
        top: 164px; /* Height of navigation -> set dynamically? */
    }
}

.webshop--sticky .filters-panel {
    @apply h-screen;
}

.webshop--sticky .search-bar {
    z-index: 70;
}
</style>
